import json_footer_en from "@/components/jsons/footer/en.json";
import json_footer_pt from "@/components/jsons/footer/pt.json";
import { Linkedin, Github, Youtube, Globe } from "lucide-react";
import CustomSelect from "../ui/select";
import styles from "@/styles/footer.module.scss";
import { useRouter } from "next/router";
import Link from "next/link";


const Footer = () => {
  const { locale } = useRouter();
  const json_footer = (locale === "pt" || locale === "br") ? json_footer_pt : json_footer_en;
  const footerSections = json_footer.sections;

  const isInternalLink = (href: string) => href.startsWith("/");
  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            {/*<h3 className="text-2xl font-bold mb-4">{footer_en.companyName}</h3>*/}
            <img
              src="/images/footer/logo_alternative.svg"
              alt="DeepNeuronic"
              className="block"
              style={{
                width: "120px",
                display: "block",
                marginBottom: "15px"
              }} />
            <p className="text-muted-foreground text-sm mb-6">
              {json_footer.companySlogan}
            </p>

            {/* Social Links */}
            <div className="flex gap-4">
              <a
                target="_blank"
                href="https://www.linkedin.com/company/deepneuronic/"
                className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center hover:border-primary hover:text-primary transition-all"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@deepneuronic9097"
                className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center hover:border-primary hover:text-primary transition-all"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
                target="_blank"
                href="https://github.com/DeepNeuronic"
                className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center hover:border-primary hover:text-primary transition-all"
              >
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h4 className="font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {isInternalLink(link.href) ? (
                      <Link
                        href={link.href}
                        className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Legal images */}
        <div className={styles.legalImagesDiv}>
          {json_footer.legalItems.map((item: any) => (
            <div
              className={styles.legalImagesDivItem}
              title={item.title}>
              {item.href === "" ? (
                <img
                  src={item.imagePath}
                  alt={item.title}
                  className={styles.legalImagesDivItemImg} />
              ) : (
                <a href={item.href} target="_blank">
                  <img
                    src={item.imagePath}
                    alt={item.title}
                    className={styles.legalImagesDivItemImg} />
                </a>
              )}
            </div>
          ))}
        </div>

        {/* Trust Bar */}
        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
              <span className="flex items-center gap-2" style={{ alignItems: "center" }}>

                <span style={{ "marginLeft": "-5px" }}>
                  <CustomSelect />
                </span>
              </span>
            </div>

            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} DeepNeuronic. {(locale === "pt" || locale === "br") ? "Todos os direitos reservados. A DeepNeuronic é uma empresa da Motorola Solutions." : "All rights reserved. DeepNeuronic is a Motorola Solutions Company."}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
